import {
  accessDenied,
  ApiActionCall,
  ApiActionTypes,
  apiEnd,
  apiError,
  apiStart,
} from '../actions/Api';
import {Action, Dispatch, Middleware} from 'redux';
import Api from '../../@crema/services/ApiConfig';
import {LOG_OUT} from '../../types/actions/Auth.actions';
import {showError} from '../actions';
import {getAuthToken} from '../selectors/Auth';

export const createApiMiddleware = (): Middleware => {
  return ({dispatch, getState}) => (next: Dispatch) => async (
    action: ApiActionCall,
  ): Promise<Action> => {
    if (action.type !== ApiActionTypes.API_CALL) {
      return next(action);
    }

    const {
      url,
      method,
      data,
      token,
      useAuthorization = true,
      onSuccess,
      onFailure,
      label,
    } = action.payload;

    dispatch(apiStart(label));

    const dataOrParams = ['GET'].includes(method) ? 'params' : 'data';

    const bearer = token || getAuthToken(getState());
    if (useAuthorization && bearer) {
      Api.defaults.headers.common['Authorization'] = `Bearer ${bearer}`;
    }

    if (!useAuthorization || (useAuthorization && bearer)) {
      try {
        let response = await Api.request({
          url,
          method,
          [dataOrParams]: data,
        });
        response = response.data || response;
        dispatch(onSuccess(response));
      } catch (error: any) {
        const errorMsg =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          String(error);

        dispatch(apiError(errorMsg));
        dispatch(onFailure(errorMsg));

        if (error.response && error.response.status === 403) {
          dispatch(showError('Unauthorized'));
          dispatch(accessDenied(window.location.pathname));
          dispatch({type: LOG_OUT});
        }
      } finally {
        dispatch(apiEnd(label));
      }
    }

    return next(action);
  };
};
